"use strict";
appHost.plugins.register({
    // #region Vars
    name: "288a.ecommerce.documents",
    // #endregion
    // #region Register
    register() {
        // #region elements
        appHost.components.registerAsync("g-document-dialog", () => import(/* webpackChunkName: "ecommerce-docs" */ "./views/g-document-search.vue"));
        appHost.components.registerAsync("g-document-fields", () => import(/* webpackChunkName: "ecommerce-docs" */ "./views/g-document-fields.vue"));
        appHost.components.registerAsync("g-document-search", () => import(/* webpackChunkName: "ecommerce-docs" */ "./views/g-document-search.vue"));
        // #endregion         
    }
    // #endregion
});
